import { ExternalLink } from 'lucide-react';
import React from 'react';

import { AD_BANNER } from '@/config/site';

export const AdBanner: React.FC = () => {
  // Ha az enabled mező false, ne jelenítsd meg a bannert
  if (!AD_BANNER.enabled) {
    return null;
  }

  return (
    <div className="w-full border-y border-neutral-800 bg-black cursor-pointer group overflow-hidden">
      <div className="relative w-full h-10 flex items-center justify-center">
        {/* Background Pattern (Industrial Stripes) */}
        <div className="absolute inset-0 bg-[repeating-linear-gradient(45deg,transparent,transparent_10px,#111_10px,#111_20px)] opacity-50" />

        {/* Hover Glow Effect */}
        <div className="absolute inset-0 bg-neon-red/0 md:group-hover:bg-neon-red/5 transition-colors duration-300" />

        {/* Content */}
        <div className="relative z-10 flex items-center gap-3 sm:gap-4 px-4 text-[10px] md:text-xs font-mono uppercase tracking-widest whitespace-nowrap">
          <span className="bg-neon-red text-black font-bold px-1.5 py-0.5">{AD_BANNER.label}</span>

          <span className="text-neutral-300 md:group-hover:text-white transition-colors flex items-center gap-2">
            <span className="hidden sm:inline text-white font-bold">{AD_BANNER.title}</span>
            <span className="text-neon-red animate-pulse font-bold">{AD_BANNER.highlight}</span>
          </span>

          <span className="hidden sm:inline text-neutral-600" aria-hidden="true">
            {'///'}
          </span>

          <a
            className="flex items-center text-neutral-400 md:group-hover:text-neon-red underline decoration-neutral-700 md:group-hover:decoration-neon-red underline-offset-4 transition-all"
            href={AD_BANNER.ctaUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {AD_BANNER.ctaLabel} <ExternalLink className="w-3 h-3 ml-1" />
          </a>
        </div>
      </div>
    </div>
  );
};
